import React, { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Benefits } from "./components/Benefits";
import { Catalog } from "./components/Catalog";
import { Plans } from "./components/Plans";
import { Testimonials } from "./components/Testimonials";
import { Faq } from "./components/Faq";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { WhatsAppFloat } from "./components/WhatsAppFloat";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error) {
        console.error("App error:", error);
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="grid min-h-screen place-items-center bg-[#070709] px-6 text-center">
                    <div>
                        <p className="font-display text-2xl font-extrabold text-white">
                            DRAX<span className="text-[#E50914]">.</span>
                        </p>
                        <p className="mt-2 text-[#94A3B8]">
                            Algo saiu do ar. Recarregue a página.
                        </p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

const Landing = () => (
    <div className="overflow-x-clip bg-[#070709] font-body text-[#F8FAFC]">
        <Navbar />
        <main>
            <Hero />
            <Marquee />
            <Benefits />
            <Catalog />
            <Plans />
            <Testimonials />
            <Faq />
            <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
    </div>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <Landing />
        </ErrorBoundary>
    );
}

export default App;
